import { CameraPickerState } from '@voltmoney/schema';
export const args = {
    state: CameraPickerState.OFF,
};
export const argTypes = {
    state: {
        control: 'select',
        options: [...Object.values(CameraPickerState)],
    },
};
